exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".warning-wrapper.show {\n  position: relative; }\n  .warning-wrapper.show .warning-message {\n    position: absolute;\n    top: -68px;\n    right: -146px;\n    left: 5px;\n    font-size: 0.75em;\n    text-transform: uppercase;\n    font-weight: bold;\n    padding: 5px 10px;\n    background: #231f20;\n    color: #f4f4f4;\n    border-radius: 4px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/Shared/WarningWrapper/WarningWrapper.scss
// module id = 1452
// module chunks = 0